import { createContext, useContext } from "react";

import { FORM_STATE } from "./constants";

interface IAuthModalContext {
    setFormState: (formState: FORM_STATE) => void;
    onAuthSuccess: VoidFunction;
    formState: FORM_STATE;
}

const EMPTY_FUNC = () => {
    /** DO NOTHING */
};
const initialValue: IAuthModalContext = {
    setFormState: EMPTY_FUNC,
    onAuthSuccess: EMPTY_FUNC,
    formState: FORM_STATE.LOGIN,
};

const AuthModalContext = createContext(initialValue);

export const useAuthModalContext = () => useContext(AuthModalContext);

export default AuthModalContext;
